import { List, ListItem, Typography } from '@mui/material';
import ProductTourContent from 'src/components/ProductTourContent';
import { IProductTour } from 'src/models/productTour';

export const CreateGroupObjectStep: IProductTour = {
  title: 'How to Prepare Group Objects',
  menu: 'settings',
  submenu: 'group',
  steps: [
    {
      title: "Let's Prepare Your Group Object!",
      content: (
        <ProductTourContent spacing={1}>
          <Typography fontSize="12px">
            The default “All Social Profile” will display all of your objects.
            You can organize objects you frequently use into groups.
          </Typography>
          <Typography fontSize="12px">For example:</Typography>
          <List sx={{ listStyleType: 'disc', mt: 0, pt: 0 }}>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              One group for a specific campaign
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              One group for your brand and another for your competitors
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              One group for profiles related to a certain client, etc.
            </ListItem>
          </List>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Start the Tour'
    },
    {
      title: 'Open Settings Menu',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Click here to open the settings menu.
        </ProductTourContent>
      )
    },
    {
      title: 'Open Group Settings',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          <Typography fontSize="12px">
            Click <strong>Manage</strong> to access group settings.
          </Typography>
        </ProductTourContent>
      )
    },
    {
      title: 'Create New Group',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          You can add group here (click the button).
        </ProductTourContent>
      )
    },
    {
      title: 'Create New Group',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Type your new group name and select Create New to go to the next step.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Add a New Social Profile',
      content: (
        <ProductTourContent direction="row" alignItems="center" spacing={1}>
          Add any object to the group by selecting it and click the “Done”
          button and your selected objects will be saved as a group.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'The Final Step',
      content: (
        <ProductTourContent spacing={2}>
          All steps are complete. You've successfully finished this stage and
          are now ready to continue exploring and using all available features.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Finish'
    }
  ]
};
